/**
 * @fileoverview Client-side validation utility functions.
 * Provides reusable validators for email format and password strength requirements.
 */

/**
 * Validates password meets strength requirements.
 * Must be 8+ characters with at least one uppercase, one lowercase, and one digit.
 *
 * @param {string} password - The password to validate
 * @returns {string|null} Error message or null if valid
 * @example
 * const error = validatePassword('test123'); // Returns error string
 * const valid = validatePassword('Test1234'); // Returns null
 */
export function validatePassword(password) {
  if (password.length < 8) {
    return 'Password must be at least 8 characters';
  }
  if (!/[A-Z]/.test(password)) {
    return 'Password must contain at least one uppercase letter';
  }
  if (!/[a-z]/.test(password)) {
    return 'Password must contain at least one lowercase letter';
  }
  if (!/[0-9]/.test(password)) {
    return 'Password must contain at least one digit';
  }
  return null;
}

/**
 * Validates email format.
 * Uses a simple regex pattern to check for basic email structure.
 *
 * @param {string} email - The email to validate
 * @returns {boolean} True if valid email format
 * @example
 * isValidEmail('user@example.com'); // Returns true
 * isValidEmail('invalid-email'); // Returns false
 */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
